import { defineComponent as _defineComponent } from 'vue'
import { onMounted, reactive, ref } from 'vue';
import { message } from 'ant-design-vue';
import SingleImageUpload from '@/component/single-image-upload.vue';
import CustomModal from '@/component/custom-modal.vue';
import moment from 'moment';
import {
  getServiceConfig,
  initServiceConfig,
  ServiceConfigData,
  editServiceConfig,
} from '@/api/operation/service_config';


export default /*#__PURE__*/_defineComponent({
  __name: 'service-config',
  setup(__props) {

const UPLOAD_DIR = ref<string>('operation/wechat-qrcode');
const is_loading = ref<boolean>(false);
const is_show_img_modal = ref<boolean>(false);
const form_item_layout = reactive<any>({ labelCol: { span: 2 }, wrapperCol: { span: 22 } });
const preview_image = ref<string>('');
const form = ref<ServiceConfigData>(initServiceConfig());

// 获取客服配置
onMounted(async () => {
  is_loading.value = true;
  const res = await getServiceConfig();
  if (res.status !== 200) {
    message.error((res as any).message);
    is_loading.value = false;
    return;
  }
  is_loading.value = false;
  form.value = initServiceConfig(res.data);
  // console.log('form', form);
  form.value.service_start_time = form.value.service_start_time
    ? moment(form.value.service_start_time, 'HH:mm')
    : null;
  form.value.service_end_time = form.value.service_end_time
    ? moment(form.value.service_end_time, 'HH:mm')
    : null;
});
function handlePreview(imageUrl: string) {
  preview_image.value = imageUrl;
  is_show_img_modal.value = true;
}
function checkTel(value: string) {
  const isPhone = /^([0-9]{3,4}-)?[0-9]{7,8}$/;
  const isMob =
    /^((\+?86)|(\(\+86\)))?(13[0123456789][0-9]{8}|15[0123456789][0-9]{8}|18[02356789][0-9]{8}|147[0-9]{8}|1349[0-9]{7})$/;
  if (isMob.test(value) || isPhone.test(value)) {
    return true;
  } else {
    return false;
  }
}

// 点击保存按钮
async function clickSaveBtn() {
  is_loading.value = true;
  if (form.value.mobile == '' && form.value.qrcode_url == '' && form.value.wechat_id == '') {
    message.error('请至少填写微信二维码、微信号、联系方式中的一项。');
    is_loading.value = false;
    return;
  }
  if (form.value.mobile) {
    if (!checkTel(form.value.mobile)) {
      message.error('请输入正确的手机号或固定电话');
      is_loading.value = false;
      return;
    }
  }
  const start_time = form.value.service_start_time
    ? form.value.service_start_time.format('HH:mm')
    : 0;
  const end_time = form.value.service_end_time ? form.value.service_end_time.format('HH:mm') : 0;
  const send_data = {
    qrcode_url: form.value.qrcode_url
      ? form.value.qrcode_url.indexOf('http') === -1
        ? `https:${form.value.qrcode_url}`
        : form.value.qrcode_url
      : '',
    wechat_id: form.value.wechat_id,
    service_start_time: start_time,
    service_end_time: end_time,
    mobile: form.value.mobile,
  };
  const res = await editServiceConfig(send_data);
  if (res.status !== 200) {
    message.error((res as any).message);
    is_loading.value = false;
    return;
  }
  // console.log('editres', res);
  message.success('上传成功');
  is_loading.value = false;
  getServiceConfig();
}

return { __sfc: true,UPLOAD_DIR, is_loading, is_show_img_modal, form_item_layout, preview_image, form, handlePreview, checkTel, clickSaveBtn, SingleImageUpload, CustomModal }
}

})